var map = {
	"./产品管理-0.svg": "5ef3",
	"./商机客户-0.svg": "def7",
	"./在用客户-0.svg": "a4bf",
	"./提现记录-0.svg": "4650",
	"./系统设置-0.svg": "7bee",
	"./组织架构-0.svg": "6e46",
	"./财务中心-0.svg": "4bdb",
	"./项目交付-0.svg": "29ea",
	"./首页-0.svg": "ddbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";